var map = {
	"./Blog.png": 7050,
	"./BlueBanner.png": 14258,
	"./Immersive-room.png": 50319,
	"./about-banner.jpg": 69228,
	"./aboutBlog.jpg": 94841,
	"./ai.webp": 70146,
	"./ar.webp": 63890,
	"./arBanner.jpg": 58441,
	"./arBanner5.jpg": 73120,
	"./arbanner2.jpg": 91716,
	"./arvrBlog.jpg": 40244,
	"./augmentedBlog.jpg": 57789,
	"./blog-page-main.jpg": 76135,
	"./blue-background.png": 98137,
	"./blue-background2.jpg": 68599,
	"./blue-bg22.jpg": 82174,
	"./codeigniter.jpg": 5932,
	"./collegeTech2.png": 68645,
	"./collegeTech3.png": 70044,
	"./constructionBlog.jpg": 20153,
	"./dinoBanner.png": 89605,
	"./event.png": 61925,
	"./event2.png": 90108,
	"./event3.png": 74350,
	"./immBlogbanner7.jpg": 85787,
	"./immersiveBlogBanner.jpg": 6121,
	"./immersiveUk.png": 97501,
	"./immersiveUk2.jpg": 63960,
	"./in.jpg": 8207,
	"./mad.jpg": 51210,
	"./mixedBlog.jpg": 38114,
	"./mr.jpg": 67430,
	"./partnerUkBlog.jpg": 5198,
	"./project-project2.jpg": 57135,
	"./projects.jpg": 70417,
	"./reducestress.jpg": 14990,
	"./services-research and innovation.jpg": 29292,
	"./technology-android.jpg": 75096,
	"./technology-angular.jpg": 18192,
	"./technology-drupal.jpg": 37648,
	"./technology-flutter.jpg": 1568,
	"./technology-hybrid.jpg": 29261,
	"./technology-ionic.jpg": 8163,
	"./technology-ios.jpg": 16355,
	"./technology-laravel.jpg": 79587,
	"./technology-magento.jpg": 26003,
	"./technology-mean.jpg": 64314,
	"./technology-mern.jpg": 92094,
	"./technology-php.jpg": 2993,
	"./technology-phython.jpg": 71271,
	"./technology-reactjs.png": 42899,
	"./technology-reactnative.jpg": 258,
	"./technology-shopify.jpg": 16979,
	"./technology-swift.jpg": 26390,
	"./technology-unity-app.jpg": 26420,
	"./technology-unreal-engine-development.webp": 61797,
	"./technology-vue.jpg": 79862,
	"./technology-worldpress.jpg": 65049,
	"./vr-360-banner.jpg": 80621,
	"./vr-banner.svg": 38812,
	"./vr-banner2.jpg": 66753,
	"./webdesign.jpg": 71167
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 86539;